module.exports = __webpack_public_path__ + "img/bloomlogo.a1f1a523.png";